import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import MetaTags from 'react-meta-tags';
import ArtistService from '../../services/artistService.js';
import * as trackActions from '../../actions/trackActions';
import * as videoActions from '../../actions/videoActions';
import ChartItemMusic from '../common/ChartItemMusic';
import ChartVideoItem from './ChartVideoItem';
import Loading from '../common/Loading';
import ShareService from '../../services/shareService.js';
import Advert from '../common/Advert.js';
import ErrorMessage from '../common/ErrorMessage.js';

class ChartPage extends React.Component {
    constructor(props, context) {
        super(props, context);
        const tabName = props.match.params.tabName || 'Music';
        //this.tabName = tabName;      
        this.getTitle = this.getTitle.bind(this);
        this.getMetaDescription = this.getMetaDescription.bind(this);
        this.loadChartData = this.loadChartData.bind(this);
        this.playPause = this.playPause.bind(this);
        this.getSelectedTab = this.getSelectedTab.bind(this);
    }

    componentWillMount() {        
        this.loadChartData();
    }

    componentDidMount() {       
        $('#btnPop').on('click', function (e) {
            e.preventDefault();
            $('#popover').toggleClass('showpop');
            e.stopPropagation();
        });
        $('body').on('click', this.removePopOver);
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.match.params.tabName != prevProps.match.params.tabName) {
            //we've changed the tab, load the data
            this.loadChartData();
        }
    }

    componentWillUnmount() {
        $('body').off('click', this.removePopOver);
    }

    removePopOver(e) {
        if ($('#popover').hasClass('showpop')) {
            $('#popover').removeClass('showpop');
        }
    }

    loadChartData() {
        if(this.getSelectedTab() == 'Music') {
            this.props.trackActions.getCharts();
        }
        else {
            this.props.videoActions.getCharts();
        }
    }

    getTitle() {
        if(this.getSelectedTab() == 'Music') {
            return 'Music Charts - Find out which artists are trending! - LoudUp';
        }
        else {
            return 'Video Charts - Find out which music videos are trending! - LoudUp';
        }
    }

    getMetaDescription() {
        if(this.getSelectedTab() == 'Music') {
            return 'Listen to the music currently trending across the site and have your say!';
        }
        else {
            return 'Watch the music videos currently trending across the site and have your say!';
        }
    }

    playPause(event, trackID) {
        event.preventDefault();
        this.props.trackActions.playPauseTrack(trackID);
    }

    getSelectedTab() {
        if(!this.props.match.params.tabName || this.props.match.params.tabName.toLowerCase() == 'music') {
            return 'Music';
        }
        else {
            return 'Videos';
        }
    }

    render() {
        const selectedTab = this.getSelectedTab();
        return (
            <div className="main">
                <MetaTags>
                    <title>{this.getTitle()}</title>            
                    <meta id="description" name="description" content={this.getMetaDescription()} />                
                </MetaTags>
                {this.props.match.params.tabName && this.props.match.params.tabName.toLowerCase() == 'music' ? <link rel="canonical" href={ShareService.getAbsoluteUrl('/Charts')} /> : null}
                <div className="container">
                    <div className="block-inner">   
                        <div className="popbox">
                            <div id="popover" className="popover">
                                <a id="btnPop" href="#" className="btn-pop transition">
                                    <div className="dot" />
                                    <svg className="icon icn-music-alert transition">
                                        <use xlinkHref="#icn-music-alert" />
                                    </svg>
                                </a>
                                <div className="inner transition2">
                                     <p>No one likes being judged but sometimes it is necessary! Here's the top 10 voted by our listeners...</p>                                
                                </div>
                            </div>
                        </div>                    
                        <header>
                            <h1 className="section-alt">
                                Charts
                            </h1>
                        </header>
                        <div className="main-content">
                            <ul className="nav nav-tabs tabs-lined" role="tablist">
                                <li className={selectedTab == 'Music' ? 'active' : ''}>
                                    <Link id="lnkMusicTrending" to="/Charts/Music" name="Music" className="transition">TRENDING MUSIC</Link>
                                </li>
                                <li className={selectedTab == 'Videos' ? 'active' : ''}>
                                    <Link id="lnkVideosTrending" to="/Charts/Videos" name="Videos" className="transition">TRENDING VIDEOS</Link>
                                </li>
                            </ul>
                            <div id="browse" className="tab-content" style={{minHeight:'200px'}}>
                                <div className="tab-pane active">
                                    { 
                                        selectedTab == 'Music' ? 
                                            this.props.music.length ?
                                                <ul id="ulHearMe" className="list-unstyled itemlist hearlist hearlist-top hearlist-top-aligned">
                                                    {
                                                        this.props.music.map((item, index) => {
                                                            return <React.Fragment key={index}>
                                                                <ChartItemMusic key={item.ID} item={item} playPause={this.playPause} index ={index} />
                                                                {
                                                                    index === 4 ?
                                                                    <li className="ext-text grey-font">
                                                                        <p style={{ paddingBottom: '5px', color: '#E55D1E', fontWeight: 'bold' }}>Sponsored Post</p>
                                                                        <Advert adType="Footer" textOnly />
                                                                    </li>
                                                                    : null
                                                                }
                                                            </React.Fragment>;
                                                        })
                                                    }
                                                </ul> 
                                                :
                                                this.props.loadingStatus === 'LOADING' ?
                                                    <Loading />
                                                    : 
                                                    this.props.loadingStatus === 'FAILED' ?
                                                        <ErrorMessage error="Sorry, something went wrong! Unable to load tracks" />
                                                        : 
                                                        <p>There are no tracks currently trending</p>                                       
                                            :                                             
                                            this.props.videos.length ?
                                                <ul id="ulHearMe" className="videolist list-unstyled itemlist hearlist hearlist-top">
                                                    {
                                                        this.props.videos.map((video, index) => {
                                                            return <React.Fragment key={index}>
                                                                <ChartVideoItem key={video.ID} video={video} index={index} actions={this.props.videoActions} showShareButton={false} showVideoName showCreator /> 
                                                                {
                                                                    index === 4 ?
                                                                    <li className="ext-text grey-font">
                                                                        <p style={{ paddingBottom: '5px', color: '#E55D1E', fontWeight: 'bold' }}>Sponsored Post</p>
                                                                        <Advert adType="Footer" textOnly />
                                                                    </li>
                                                                    : null
                                                                }
                                                            </React.Fragment>;
                                                        })
                                                    }   
                                                </ul>  
                                                :
                                                this.props.loadingStatus == 'LOADING' ?
                                                    <Loading />
                                                    :
                                                    this.props.loadingStatus === 'FAILED' ?
                                                        <ErrorMessage error="Sorry, something went wrong! Unable to load videos" />
                                                        :  
                                                        <p>There are no videos currently trending</p>
                                            
                                                                               
                                    }
                                </div>   
                            </div>                     
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ChartPage.propTypes = {
    music: PropTypes.array.isRequired,
    videos: PropTypes.array.isRequired,
    trackActions: PropTypes.object.isRequired,
    videoActions: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    loadingStatus: PropTypes.string
};

function mapStateToProps(state, ownProps) {
    const isMusic = !ownProps.match.params.tabName || ownProps.match.params.tabName.toLowerCase() == 'music';
    const loadingStatus = isMusic ? state.tracks.chartLoadingStatus : state.videos.chartLoadingStatus;
    let status = null;
    if(loadingStatus) {
        status = loadingStatus.status;
    }
    return { 
        music: state.tracks.charts, 
        videos: state.videos.charts, 
        loadingStatus: status
    };
}

function mapDispatchToProps(dispatch) {
    return {
        trackActions: bindActionCreators(Object.assign({}, trackActions), dispatch),
        videoActions: bindActionCreators(Object.assign({}, videoActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ChartPage);
